const SafetyIconBreathableMask3 = ({
  className,
}: { className?: string } = {}) => (
  <svg
    className={className}
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="36"
      height="36"
      rx="18"
      fill="#FFD41C"
    />
    <path
      d="M11.4 14.4999C13.0126 13.8257 15.371 13.4 18 13.4C20.629 13.4 22.9874 13.8257 24.6 14.4999M14.7 17.2499C15.734 16.8935 16.845 16.6999 18 16.6999C19.155 16.6999 20.266 16.8935 21.3 17.2499M13.6 21.0999C14.8947 21.7995 16.3973 22.1999 18 22.1999C19.5353 22.2044 21.0475 21.8264 22.4 21.0999M11.4 15.5999C11.4 19.1826 9.3859 21.0361 8.1627 21.0988C8.14327 21.0999 8.12394 21.0953 8.10711 21.0855C8.09029 21.0758 8.07672 21.0612 8.0681 21.0438C7.1727 19.4477 7 17.5678 7 15.5999C7 11.9546 7.9845 9 9.2 9C10.4155 9 11.4 11.9546 11.4 15.5999ZM24.6 15.5999C24.6 19.1826 26.6141 21.0361 27.8373 21.0988C27.8567 21.0999 27.8761 21.0953 27.8929 21.0855C27.9097 21.0758 27.9233 21.0612 27.9319 21.0438C28.8273 19.4477 29 17.5678 29 15.5999C29 11.9546 28.0155 9 26.8 9C25.5845 9 24.6 11.9546 24.6 15.5999Z"
      stroke="#171717"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.8996 21.0996C25.9229 24.3875 22.2302 26.5996 17.9996 26.5996C13.769 26.5996 10.0752 24.3875 8.09961 21.0996"
      stroke="#171717"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SafetyIconBreathableMask3
